import { Link } from "react-router-dom";

const RAYS = [-200, -176, -152, -128, -104, -80, -56, -32].map((a, i) => {
  const r = (a * Math.PI) / 180;
  const [r1, r2] = [11.5, i % 2 ? 15.5 : 18];
  return { x1: 22 + r1 * Math.cos(r), y1: 19 + r1 * Math.sin(r), x2: 22 + r2 * Math.cos(r), y2: 19 + r2 * Math.sin(r) };
});

export const LogoMark = ({ className = "h-10 w-12" }) => (
  <svg viewBox="0 0 64 50" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="sed-sun" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#FFD27A" /><stop offset="1" stopColor="#E08A0B" /></linearGradient>
      <linearGradient id="sed-panel" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#2a3242" /><stop offset="1" stopColor="#0d1016" /></linearGradient>
      <linearGradient id="sed-silver" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stopColor="#FFFFFF" /><stop offset="1" stopColor="#9CA3AF" /></linearGradient>
    </defs>
    <g stroke="url(#sed-sun)" strokeWidth="2" strokeLinecap="round">
      {RAYS.map((r, i) => <line key={i} {...r} />)}
    </g>
    <circle cx="22" cy="19" r="9" fill="url(#sed-sun)" />
    <path d="M12 41 L26 22 L38.5 38.5" fill="#08090a" stroke="url(#sed-silver)" strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round" />
    <path d="M26 22 L44 20 L58 36.5 L38.5 38.5 Z" fill="url(#sed-panel)" stroke="url(#sed-silver)" strokeWidth="1.6" strokeLinejoin="round" />
    <g stroke="rgba(209,213,219,0.75)" strokeWidth="0.8">
      <line x1="30.2" y1="27.5" x2="48.7" y2="25.5" /><line x1="34.3" y1="33" x2="53.3" y2="31" />
      <line x1="30.5" y1="21.5" x2="43.4" y2="37.9" /><line x1="35" y1="21" x2="48.3" y2="37.5" /><line x1="39.5" y1="20.5" x2="53.2" y2="37" />
    </g>
    <g fill="url(#sed-silver)">
      <rect x="21.3" y="30" width="2.6" height="2.6" /><rect x="24.5" y="30" width="2.6" height="2.6" />
      <rect x="21.3" y="33.2" width="2.6" height="2.6" /><rect x="24.5" y="33.2" width="2.6" height="2.6" />
    </g>
    <path d="M8 43.5 C22 47.5 40 46 59 40.5" fill="none" stroke="url(#sed-sun)" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ testId = "nav-brand-logo" }) => (
  <Link to="/" data-testid={testId} className="group flex items-center gap-2.5 sm:gap-3" aria-label="Solar Energy Doc home">
    <span className="transition-transform duration-700 group-hover:-translate-y-0.5 group-hover:scale-105">
      <LogoMark className="h-10 w-12 sm:h-11 sm:w-14" />
    </span>
    <span className="flex flex-col leading-none">
      <span className="font-display whitespace-nowrap text-[13px] sm:text-[15px] font-bold tracking-[0.12em] text-white">SOLAR</span>
      <span className="mt-1 whitespace-nowrap font-display text-[9.5px] sm:text-[10.5px] font-medium tracking-[0.2em] text-amber-400">ENERGY DOC <span className="text-zinc-400">LLC</span></span>
      <span className="mt-1 hidden sm:block font-mono text-[8.5px] uppercase tracking-[0.28em] text-zinc-400">Quality You Can Trust</span>
    </span>
  </Link>
);
